import { CsvButton } from '@components/Buttons/CsvButton';
import { Pagination } from '@components/Table/Pagination';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IRelatorioValoresEmitidosFilter, IRelatorioValoresEmitidosRecord } from '@services/Relatorios/ValoresEmitidosService';
import React from 'react';

export type RelatorioValoresEmitidosTableProps = {
    data: IData<IRelatorioValoresEmitidosRecord, IRelatorioValoresEmitidosFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function RelatorioValoresEmitidosTable ({ data, isLoading, onCsvButtonClick }: RelatorioValoresEmitidosTableProps) {
    const formatter = useFormatter();

    return (
        <React.Fragment>
            <TableWrapper>
                <TableLinearLoading isLoading={isLoading} />
                <TableNoResult itemCount={data.itemsCount}>
                    <TableHead>
                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>

                        <TableSortRow sort={data.sort}>
                            <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                            <TableSortCell fieldName="quantidade">Quantidade</TableSortCell>
                            <TableSortCell fieldName="total">Total</TableSortCell>
                        </TableSortRow>
                    </TableHead>
                    
                    <TableBody>
                        {
                            data.items.map((valoresEmitidos, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{valoresEmitidos.empresaNome}</TableCell>
                                        <TableCell>{valoresEmitidos.quantidade}</TableCell>
                                        <TableCell>{formatter.toFloat(valoresEmitidos.total)}</TableCell>
                                    </TableRow>
                                )
                            })
                        }

                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>

                    </TableBody>
                </TableNoResult>
            </TableWrapper>
        </React.Fragment>
    )
}